import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IDividerConfiguration, IDividerProps, IDividerState } from './models/index.js';
import { dividerStyle } from './styles/Divider.style.js';
import { DIVIDER_CATEGORY_KEY, DIVIDER_COMPONENT_KEY } from './Divider.meta.js';

export class Divider extends ComponentBase<IDividerProps, IDividerState, IDividerConfiguration> {
	categoryKey = DIVIDER_CATEGORY_KEY;
	componentKey = DIVIDER_COMPONENT_KEY;

	constructor(props: IDividerProps) {
		super(props);
	}

	static defaultProps: IDividerProps = {
		orientation: 'horizontal',
	};

	render() {
		const { orientation } = this.props;

		const classes = this.appendClassNames(orientation);

		return (
			<div className={classes} role="presentation" data-selector={this.selector}>
				&nbsp;
			</div>
		);
	}
}

export default InjectedStyledComponent(
	observer(Divider),
	DIVIDER_CATEGORY_KEY,
	DIVIDER_COMPONENT_KEY,
	undefined,
	undefined,
	undefined,
	dividerStyle,
);
